module.exports = __webpack_public_path__ + "img/summary_battery_import.938ca0f0.svg";